import { InfluencerProfileSponsoredPosts, InfluencerProfileSponsoredPostsProps } from '../shared';

export type InfluencerYoutubeProfileSponsoredPostsProps = InfluencerProfileSponsoredPostsProps;

export const InfluencerYoutubeProfileSponsoredPosts = (props: InfluencerYoutubeProfileSponsoredPostsProps) => (
  <InfluencerProfileSponsoredPosts {...props} />
);
